<template>
    <div class="home-teacher-content">
        <!-- Header -->

        <div class="container-fluid ind-head">
            <div class="container align-middle">
                <div class="row desktop-vers">
                    <div class="col-sm-3 home-logo">
                        <a href="/"><img :src="$t('logo_home')"></a>
                        <div class="ind-slogan-home de">{{ $t('header_slogan') }}</div>
                    </div>
                    <div class="col-sm-6 home-ceneter-menu align-self-center order-3 order-sm-2">
                        <div class="row">
                            <div class="col-sm mgtop-0">

                                <a href="/#langs" class="topmenu-home">Fächer und Fremdsprachen</a>
                                <a href="/#how">So geht es!</a>
                                <a href="/home-teacher/entry">Infos</a>
                                <!--<div class="dop"><a href="" class="topmenu-home">Zusätzliche Formate</a>
                                  <ul class="dopformat">
                                    <li><a href="/hometeacher.html">Heimlehrer</a></li>
                                    <li><a href="/home-teacher/onlineteacher">OnlineLehrer</a></li>
                                    <li><a href="/home-teacher/individual">Einzelsitzungen</a></li>
                                  </ul></div> -->
                                <!-- <a href="/home-teacher/exams" class="topmenu-home">Tests</a>
                                <br>
                                <a href="/about.html">Über uns</a>
                                <a href="#">Impressum</a>
                                <a href="https://jivo.chat/ZYd83bdadh" target="_blank">Online Chat </a>-->

                                <!-- <a href="https://www.poliglotiki.ru/index_all" target="_blank">Präsenzunterricht</a> -->
                                <!--<div class="divstartfree"><a href="/home-teacher/try-free" class="startfree">Начать бесплатно</a></div> -->
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm home-main-title">
                                <div class="ind-h1">{{ $t('header_title') }}</div>
                            </div>

                        </div>

                    </div>
                    <div class="col-sm-3 home-right-menu order-2 order-sm-3">
                        <div class="row">

                            <div class="col-sm home-main-faq">
                                <div style="margin-top: -10px; margin-bottom: 10px;"><a href="/faq.html" class="faq-a">{{ $t('ask_a_question') }}</a></div>
                                <a href="/commencez-a-apprendre-des-langues.html"><img src="@/assets/hometeacher/images/fr.png"></a>
                                <a href="/start-learning-foreign-languages-china.html"><img src="@/assets/hometeacher/images/ch.png"></a>
                                <a href="/nachnite-izuchat-inostrannye-yazyki.html"><img src="@/assets/hometeacher/images/ru.png"></a>
                                <a href="/start-learning-foreign-languages.html"><img src="@/assets/hometeacher/images/en.png"></a>
                                <a href="/pochnit-vivchati-inozemni-movi.html"><img src="@/assets/hometeacher/images/ua.png"></a>
                                <a href="/empezad-a-estudiar-las-lenguas-extranjeras-ahora-mismo.html"><img src="@/assets/hometeacher/images/es.png"></a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm">
                                <div class="wttg">
                                    <!-- <a target="_blank" title="Telegram" rel="nofollow" href="https://t.me/PoliglotikiHomeTeacherBot"><img src="@/assets/hometeacher/images/tlg-small.png"></a> -->
                                    <a target="_blank" title="WhatsApp" rel="nofollow" href="https://wa.me/4915256996902"><img src="@/assets/hometeacher/images/wa-small.png"></a>
                                    <div class="tlf"><a :href="`tel:${$t('support_phone')}`" style="margin-left: 7px;">{{ $t('support_phone') }}</a></div>
                                </div>
                            </div>
                        </div>
                        <div class="row">

                            <div class="col-sm text-right" v-if="user">
                                <base-dropdown class="nav-item" position="right">
                                    <a slot="title" class="nav-link p-0" href="javascript:void(0);" role="button">
                                        <div class="media align-items-center">
                                            <i class="fa fa-chevron-down mr-2"></i>
                                            <span class="rounded-circle">
                                            <img src="poliimg/ic_user_top.png" />
                                        </span>
                                        </div>
                                    </a>

                                    <div class=" dropdown-header noti-title">
                                        <h6 class="text-overflow m-0" v-if="user.email">{{ user.email }}</h6>
                                        <h6 class="text-overflow m-0" v-else-if="user.phone">{{ user.phone }}</h6>
                                    </div>

                                    <router-link to="/user/profile" class="dropdown-item">
                                        <i class="ni ni-single-02"></i>
                                        <span>{{ $t('my_profile') }}</span>
                                    </router-link>

                                    <div class="dropdown-divider"></div>
                                    <router-link to="/user/logout" class="dropdown-item">
                                        <i class="ni ni-user-run"></i>
                                        <span>{{ $t('logout') }}</span>
                                    </router-link>
                                </base-dropdown>
                            </div>
                            <div class="col-sm ind-home-reg" v-else>
                                <router-link to="/user/signin">{{ $t('login') }}</router-link>
                                /
                                <router-link to="/user/signin">{{ $t('register') }}</router-link>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="row mobile-vers">
                    <div class="col-12 mobile-reg mgbt-ind">
                      <div class="mobile-en">
                        <a href="/empezad-a-estudiar-las-lenguas-extranjeras-ahora-mismo.html">ES</a>
                      </div>
                      <div class="mobile-ru">
                        <a href="/pochnit-vivchati-inozemni-movi.html">UA</a>
                      </div>
                        <div class="mobile-en">
                            <a href="/start-learning-foreign-languages.html">EN</a>
                        </div>
                        <div class="mobile-ru">
                            <a href="/nachnite-izuchat-inostrannye-yazyki.html">RU</a>
                        </div>
                        <div class="mobile-en">
                          <a href="/start-learning-foreign-languages-china.html">CH</a>
                        </div>
                        <div class="mobile-ru">
                          <a href="/commencez-a-apprendre-des-langues.html">FR</a>
                        </div>
                        <div class="mobile-faq">
                            <div class="tlf-mobile">
                                <img src="@/assets/hometeacher/images/tlf-mobile.png">
                                <div class="galniz"></div>
                                <div class="contact">
                                    <a :href="`tel:${$t('support_phone')}`" style="margin-left: 7px;">{{ $t('support_phone') }}</a>
                                    <a v-if="$t('wa_link')" target="_blank" title="WhatsApp" rel="nofollow" :href="$t('wa_link')"><img src="@/assets/hometeacher/images/wa-top.png" class="miniw"></a>
                                    <a v-if="$t('tg_link')" target="_blank" title="Telegram" rel="nofollow" :href="$t('tg_link')"><img src="@/assets/hometeacher/images/tlg-top.png" class="miniw"></a>
                                </div>
                            </div>

                            <div class="faq-mobile">
                                <a href="/faq.html"><img src="@/assets/hometeacher/images/faq-home.png"></a>
                            </div>

                        </div>
                        <div class="mobile-registr">
                            <router-link to="/user/profile" v-if="user">{{ $t('account') }}</router-link>
                            <router-link to="/user/signin" v-else>{{ $t('login') }}/{{ $t('register') }}</router-link>
                        </div>

                        <div class="logo-mobile">
                            <a href="/"><img :src="$t('logo_home')" class="mobile-logo"></a>
                            <div class="slogan-home slogan-mobile">{{ $t('header_slogan') }}</div>
                        </div>
                        <input type="checkbox" id="btn-menu" />
                        <label for="btn-menu"><img src="@/assets/hometeacher/images/menu-mobile.png" class="menu-mobile"></label>
                        <ul class="list-menu">
                            <li><a href="/home-teacher/courses?lang=1">{{ $t('english') }}</a></li>
                            <li><a href="/home-teacher/courses?lang=4">{{ $t('french') }}</a></li>
                            <li><a href="/home-teacher/courses?lang=3">{{ $t('german') }}</a></li>
                            <li><a href="/home-teacher/courses?lang=2">{{ $t('spanish') }}</a></li>
                            <li><a href="/home-teacher/courses?lang=5">{{ $t('chinese') }}</a></li>
                            <li><a href="/home-teacher/courses?lang=6">{{ $t('russian') }}</a></li>
                        </ul>
                    </div>

                    <div class="col-sm mobile-zan-head">{{ $t('header_title_mob') }}</div>
                    <div class="divstartfree"><a href="/home-teacher/try-free" class="startfree">{{ $t('try_free') }}</a></div>

                </div>
            </div>
        </div>

        <!-- Page content -->
        <router-view></router-view>

        <!-- Footer -->
        <div class="container-fluid ind-head">
            <div class="container align-middle">
                <div class="row desktop-vers">
                    <div class="col-12 col-sm-3">
                        <a href="/"><img :src="$t('logo_home')" style="margin-top: 15px; max-width: 100%;"></a>
                        <div class="ind-slogan-home de slogan-footer">{{ $t('header_slogan') }}</div>
                    </div>
                    <div class="col-12 col-sm-9 desktop-footer">
                        <div class="row">
                            <div class="col-sm home-footer-menu">
                                <a href="/home-teacher/courses" class="topmenu-home">Alle Kurse</a>
                                <a href="/about.html" class="topmenu-home">Über uns</a>
                                <a href="/contacts-de.html" class="topmenu-home">Impressum</a>
                                <a href="https://jivo.chat/ZYd83bdadh" class="topmenu-home" target="_blank">Online Chat </a>
                                <div class="wttgfoot">
                                    <!--<a target="_blank" title="Telegram" rel="nofollow" href="https://t.me/PoliglotikiHomeTeacherBot"><img src="/images/telgram.png"></a>-->
                                    <a target="_blank" title="WhatsApp" rel="nofollow" href="https://wa.me/4915256996902"><img src="/images/whatsapp.png"></a>
                                </div>
                            </div>

                        </div>
                        <div class="row home-lang">
                            <a href="/home-teacher/courses?lang=1">{{ $t('english') }}</a>
                            <a href="/home-teacher/courses?lang=4">{{ $t('french') }}</a>
                            <a href="/home-teacher/courses?lang=3">{{ $t('german') }}</a>
                            <a href="/home-teacher/courses?lang=2">{{ $t('spanish') }}</a>
                            <a href="/home-teacher/courses?lang=5">{{ $t('chinese') }}</a>
                            <a href="/home-teacher/courses?lang=6">{{ $t('russian') }}</a>
                        </div>
                    </div>
                </div>
                <div class="row mobile-vers">
                    <div class="col-12 mobile-footer-ind-new" style="padding-top: 30px;">
                        <div class="socseti-new">
                            <a v-if="$t('yt_link')" :href="$t('yt_link')" class="ytb" target="_blank" rel="nofollow"></a>
                            <a v-if="$t('inst_link')" :href="$t('inst_link')" class="insta" target="_blank" rel="nofollow"></a>
                            <a v-if="$t('vk_link')" :href="$t('vk_link')" class="vk" target="_blank" rel="nofollow"></a>
                            <a v-if="$t('fb_link')" :href="$t('fb_link')" class="fb" target="_blank" rel="nofollow"></a>
                            <a v-if="$t('tg_link')" :href="$t('tg_link')" class="tg" target="_blank" rel="nofollow"></a>
                            <a v-if="$t('wa_link')" :href="$t('wa_link')" class="wht-y" target="_blank" rel="nofollow"></a>
                        </div>


                        <div class="mobile-footer-menu mgtop-30">
                            <!-- <p><a href="https://www.poliglotiki.ru/index_all" class="ochniye">Präsenzunterricht</a></p> -->
                            <p><a href="/home-teacher/courses?lang=1">{{ $t('english') }}</a>&nbsp;&nbsp;&nbsp;&nbsp;<a href="/home-teacher/courses?lang=4">{{ $t('french') }}</a><br>
                                <a href="/home-teacher/courses?lang=3">{{ $t('german') }}</a>&nbsp;&nbsp;&nbsp;&nbsp;<a href="/home-teacher/courses?lang=2">{{ $t('spanish') }}</a><br>
                                <a href="/home-teacher/courses?lang=5">{{ $t('chinese') }}</a>&nbsp;&nbsp;&nbsp;&nbsp;<a href="/home-teacher/courses?lang=6">{{ $t('russian') }}</a></p>

                            <!--<p><a href="/home-teacher/courses?age=1">Vorschulkind</a>&nbsp;&nbsp;&nbsp;&nbsp;<a href="/home-teacher/courses?age=3">Elternteil</a><br>
                              <a href="/home-teacher/courses?age=2">Schüler Klasse 1-4</a></p> -->

                            <div class="mobik">
                                <a href="/home-teacher/courses">Alle Kurse</a><br>
                                <a href="/about.html">Über uns</a><br>
                                <a href="/contacts-de.html">Impressum</a><br>
                                <a href="https://jivo.chat/ZYd83bdadh" target="_blank">Online Chat </a><br>
                                <a href="/user-agreement-de.html">Nutzungsbedingungen</a><br>
                                <a href="/privacy-de.html">Datenschutz</a><br>
                                <!-- <a href="/about.html" class="about">Über das Unternehmen</a></br>
                                <a href="/polzovatelskoe-soglashenie.html" class="about">Nutzungsbedingungen</a><br>
                                <a href="/delimsya-sekretami.html" class="about">Geheimnisse teilen</a> -->
                            </div>

                            <div class="phone-footer-mobile"><a :href="`tel:${$t('support_phone')}`">{{ $t('support_phone') }}</a>
                                <div>
                                    <a href="/"><img :src="$t('logo_home')"></a>
                                    <div class="ind-slogan-home de foot-slogan">{{ $t('header_slogan') }}</div>
                                </div>
                            </div>

                            <div class="adwards">
                                <!-- <img src="images/history-dp.png">
                                 <img src="images/toprbk50.png">
                                 <img src="images/history-forbs.png"> -->
                            </div>
                            <!-- <p style="margin-bottom:20px;"><a href="/home-teacher/entry" class="obratniy" target="_blank">Обратный звонок</a></p>-->
                        </div>
                    </div>
                </div>
                <div class="row desktop-footer">
                    <div class="col-12 col-sm-3">
                        <div class="socseti">
                            <a v-if="$t('yt_link')" :href="$t('yt_link')" class="ytb" target="_blank" rel="nofollow"></a>
                            <a v-if="$t('inst_link')" :href="$t('inst_link')" class="insta" target="_blank" rel="nofollow"></a>
                            <a v-if="$t('vk_link')" :href="$t('vk_link')" class="vk" target="_blank" rel="nofollow"></a>
                            <a v-if="$t('fb_link')" :href="$t('fb_link')" class="fb" target="_blank" rel="nofollow"></a>
                            <a v-if="$t('tg_link')" :href="$t('tg_link')" class="tg" target="_blank" rel="nofollow"></a>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">

                        <div class="row home-lang">
                            <!-- <a href="/home-teacher/courses?age=1">Vorschulkind</a>
                            <a href="/home-teacher/courses?age=2">Schüler Klasse 1-4</a>
                            <a href="/home-teacher/courses?age=3">Elternteil</a> -->
                        </div>
                        <div class="row home-lang">
                            <!--<a href="/about.html" class="about">Über das Unternehmen</a>	<a href="polzovatelskoe-soglashenie.html" class="about">Nutzungsbedingungen</a>
                            <a href="/delimsya-sekretami.html" class="about">Geheimnisse teilen</a>-->

                            <a href="/user-agreement-de.html" class="about">Nutzungsbedingungen</a>
                            <a href="/privacy-de.html" class="about">Datenschutz</a>

                        </div>
                    </div>
                    <div class="col-12 col-sm-3 medal">
                        <!-- <img src="images/history-dp.png">
                         <img src="images/toprbk50.png">
                         <img src="images/history-forbs.png"> -->
                    </div>
                </div>
            </div>
        </div>


        <div class="container-fluid footer-last">
            <div class="container align-middle">
                <div class="row">

                    <div class="col-12 col-lg-9 fl-copyright">
                        <div class="fl-copyright-wrap"><span class="strong-black">© {{year}}
                            {{ $t('POLIGLOTIKI') }}</span> - {{ $t('footer_slogan') }}
                        </div>
                    </div>
                    <div class="col-12 col-lg-3 fl-counters">
                        <router-link to="/entry">{{ $t('callback') }}</router-link>
                    </div>
                </div>
            </div>
        </div>

        <!--
        <div class="callback-click"
             style="position: fixed;left: 10px;bottom: 10px;border-radius: 50%;padding: 10px;background-color: #ffffffa3;">
            <a href="/home-teacher/entry" title="Обратный звонок"><img src="@/assets/poliglotiki/images/callback2.gif"
                                               style="width: 100px;"></a>
        </div>
        -->

    </div>
</template>

<style src="@/assets/hometeacher/css/main.css">
</style>
<script>

    import {getUser} from "../data/jwt.service";

    export default {
        name: 'site-layout',
        data() {
            return {
                year: new Date().getFullYear(),
                showMenu: false,
                user: null,
            }
        },
        mounted() {
            this.user = getUser()
        }
    }
</script>
<style>
</style>
